import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import LanguageDropdown from "../utility/LanguageDropdown";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { MdKeyboardArrowDown } from "react-icons/md";
import { IoWalletOutline } from "react-icons/io5";

import {
  FaHome,
  FaBlog,
  FaAddressBook,
  FaInfoCircle,
  FaUserMd,
  FaGraduationCap,
  FaFolder,
  FaAngleRight,
} from "react-icons/fa";
import { BsCart3, BsPersonCircle } from "react-icons/bs";

import { FaChevronLeft } from "react-icons/fa";
import { useCart } from "../contextApi/cartContext";
import SignInModal from "../utility/SignInModal";
import SignUpModal from "../utility/SignupModal";
import { useLanguage } from "../contextApi/languageContext";
import { FiCreditCard, FiLogOut, FiShoppingCart, FiUser } from "react-icons/fi";
import { useUser } from "../contextApi/userContext";

const MainMenu = ({
  menuItems,
  onServicesClick,
  subMenuItems,
  toggleMobileMenu,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [activePanel, setActivePanel] = useState("main");
  const [menuHistory, setMenuHistory] = useState([]);
  const [currentSubmenu, setCurrentSubmenu] = useState(null);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [showSignIn, setShowSignIn] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const { language } = useLanguage();

  const { cartItems } = useCart();
  const { logout, isLoggedIn } = useUser();
  const navigate = useNavigate();
  const toggleUserDropdown = () => {
    setShowUserDropdown(!showUserDropdown);
  };
  const handleUserOptionClick = (option) => {
    setShowUserDropdown(false);
    setIsMobileMenuOpen(false);
    // Handle different user options here
    switch (option) {
      case "profile":
        navigate("/profile");
        break;
      case "wallet":
        navigate("/wallet");
        break;
      case "cart":
        navigate("/cart");
        break;
      case "login":
        navigate("/claim-rewards");
        break;
      case "logout":
        logout();
        break;
      default:
        break;
    }
  };

  const handleClose = () => setShowModal(false);

  const iconMap = {
    Home: <FaHome />,
    Blog: <FaBlog />,
    "Contact us": <FaAddressBook />,
    About: <FaInfoCircle />,
    Services: <FaUserMd />,
    Training: <FaGraduationCap />,
  };

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const navigateToPanel = (panelName, submenu = null) => {
    setMenuHistory([...menuHistory, activePanel]);
    setActivePanel(panelName);
    if (submenu) setCurrentSubmenu(submenu);
  };

  const navigateBack = () => {
    if (menuHistory.length > 0) {
      const previousPanel = menuHistory[menuHistory.length - 1];
      setMenuHistory(menuHistory.slice(0, -1));
      setActivePanel(previousPanel);

      if (previousPanel.startsWith("services-")) {
        setCurrentSubmenu(
          subMenuItems.find(
            (submenu, index) => `services-${index}` === previousPanel
          )
        );
      } else if (previousPanel.startsWith("child-")) {
        setCurrentSubmenu(
          currentSubmenu?.children?.find(
            (child, index) => `child-${index}` === previousPanel
          )
        );
      } else {
        setCurrentSubmenu(null);
      }
    }
  };

  const renderMainMenu = () => (
    <ul className="mobile-menu__list">
      {menuItems.map((item, index) => (
        <li key={index} className="mobile-menu__item mt-3">
          {item?.name === "Services" ? (
            <Link
              className="mobile-menu__link mobile-menu__link--expandable shadow-effect d-flex align-items-center mb-2 mt-2"
              onClick={(e) => {
                e.preventDefault();
                navigateToPanel("services");
              }}
            >
              <span className="d-flex align-items-center py-2">
                <span
                  className="d-flex align-items-center justify-content-center rounded-circle shadow"
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: "#fff",
                    border: "1px solid #c69933",
                  }}
                >
                  {iconMap[item.name] || <FaFolder />}
                </span>

                {language === "ar" ? (
                  <span className="ms-2">{item.arabic_name}</span>
                ) : (
                  <span className="ms-2">{item.name}</span>
                )}
              </span>
              <FaAngleRight className="ms-auto" />
            </Link>
          ) : (
            <Link
              to={item?.link}
              className="mobile-menu__link shadow-effect d-flex align-items-center"
              onClick={() => {
                toggleMobileMenu();
              }}
            >
              <span className="d-flex align-items-center mb-2">
                <span
                  className="d-flex align-items-center justify-content-center rounded-circle shadow"
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: "#fff",
                    border: "1px solid #c69933",
                  }}
                >
                  {iconMap[item.name] || <FaFolder />}
                </span>
                {language === "ar" ? (
                  <span className="ms-2">{item.arabic_name}</span>
                ) : (
                  <span className="ms-2">{item.name}</span>
                )}
              </span>
            </Link>
          )}
        </li>
      ))}
      <Link
        to="/wallet"
        className="mobile-menu__link shadow-effect d-flex align-items-center"
        onClick={() => {
          toggleMobileMenu();
        }}
      >
        <span className="d-flex align-items-center mb-2 mt-2">
          <span
            className="d-flex align-items-center justify-content-center rounded-circle shadow"
            style={{
              width: "32px",
              height: "32px",
              backgroundColor: "#fff",
              border: "1px solid #c69933",
            }}
          >
            <IoWalletOutline />
          </span>
          {language === "ar" ? (
            <span className="ms-2"> Arabic </span>
          ) : (
            <span className="ms-2"> Wallet </span>
          )}
        </span>
      </Link>
    </ul>
  );

  const renderServicesMenu = () => (
    <div className="mobile-submenu">
      <button className="mobile-submenu__back" onClick={navigateBack}>
        <FaChevronLeft className="fs-1" />
        Back
      </button>
      <ul className="mobile-submenu__list">
        {subMenuItems?.map((submenu, index) => (
          <li key={index} className="mobile-submenu__item">
            {submenu?.children?.length > 0 ? (
              <div
                className="mobile-submenu__link mobile-submenu__link--expandable d-flex align-items-center shadow-effect"
                onClick={(e) => {
                  e.preventDefault();
                  navigateToPanel(`services-${index}`, submenu);
                }}
                style={{ marginBottom: "12px", padding: "15px 15px" }} // Increased spacing
              >
                {submenu?.thumbnail ||
                  (submenu?.icons && (
                    <span
                      className="d-flex justify-content-center align-items-center rounded-circle shadow-icon"
                      style={{
                        width: "36px",
                        height: "36px",
                        backgroundColor: "#fff",
                        border: "1px solid #c69933",
                      }}
                    >
                      <img
                        src={
                          submenu?.thumbnail || "https://via.placeholder.com/30"
                        }
                        alt="Avatar"
                        className="rounded-circle"
                        width="24"
                        height="24"
                      />
                    </span>
                  ))}

                {language === "ar" ? (
                  <span className="ms-2">{submenu.arabic_name}</span>
                ) : (
                  <span className="ms-2">{submenu.name}</span>
                )}

                <FaAngleRight className="ms-auto" />
              </div>
            ) : (
              <Link to={submenu.path} className="mobile-submenu__link">
                {language === "ar" ? (
                  <span className="ms-2">{submenu.arabic_name}</span>
                ) : (
                  <span className="ms-2">{submenu.name}</span>
                )}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );

  const renderChildMenu = () => (
    <div className="mobile-submenu">
      <button className="mobile-submenu__back" onClick={navigateBack}>
        <FaChevronLeft className="fs-1" />
        Back
      </button>

      {language === "ar" ? (
        <h3 className="mobile-submenu__title">{currentSubmenu?.arabic_name}</h3>
      ) : (
        <h3 className="mobile-submenu__title">{currentSubmenu?.name}</h3>
      )}

      <ul className="mobile-submenu__list">
        {currentSubmenu?.children?.map((child, index) => (
          <li key={index} className="mobile-submenu__item">
            {child?.children?.length > 0 ? (
              <div
                className="mobile-submenu__link mobile-submenu__link--expandable d-flex align-items-center shadow-effect"
                onClick={(e) => {
                  e.preventDefault();
                  navigateToPanel(`child-${index}`, child);
                }}
                style={{ marginBottom: "12px", padding: "15px 15px" }}
              >
                <span
                  className="d-flex justify-content-center align-items-center rounded-circle shadow-icon"
                  style={{
                    width: "36px",
                    height: "36px",
                    backgroundColor: "#fff",
                    border: "1px solid #c69933",
                  }}
                >
                  <img
                    src={child?.icons || "https://via.placeholder.com/30"}
                    alt="Avatar"
                    className="rounded-circle"
                    width="25"
                    height="25"
                  />
                </span>

                {language === "ar" ? (
                  <span className="ms-2">{child.arabic_name}</span>
                ) : (
                  <span className="ms-2">{child.name}</span>
                )}

                <FaAngleRight className="ms-auto" />
              </div>
            ) : (
              <Link to={child?.path} className="mobile-submenu__link">
                {language === "ar" ? (
                  <span className="ms-2">{child.arabic_name}</span>
                ) : (
                  <span className="ms-2">{child.name}</span>
                )}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );

  const renderNestedMenu = () => (
    <div className="mobile-submenu">
      <button className="mobile-submenu__back" onClick={navigateBack}>
        <FaChevronLeft className="fs-1" />
        Back
      </button>

      {language === "ar" ? (
        <h3 className="mobile-submenu__title">{currentSubmenu?.arabic_name}</h3>
      ) : (
        <h3 className="mobile-submenu__title">{currentSubmenu?.name}</h3>
      )}

      <ul className="mobile-submenu__list">
        {currentSubmenu?.children?.map((nestedChild, index) => (
          <li
            key={index}
            className="mobile-submenu__item"
            style={{ padding: "5px 0" }}
          >
            <Link
              className="mobile-submenu__link shadow-effect"
              onClick={(e) => {
                e.preventDefault();
                toggleMobileMenu();
                navigate(nestedChild?.link);
              }}
            >
              {language === "ar" ? nestedChild.arabic_name : nestedChild.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className="">
      {!isMobile ? (
        <>
          <div className="d-flex justify-content-center align-items-center">
            <ul className="d-flex gap-4 list-unstyled align-items-center mt-4 mr-4">
              {menuItems.map((item, index) => (
                <li
                  key={index}
                  className={
                    item.children && item.children.length > 0 ? "" : ""
                  }
                >
                  {item?.name === "Services" ? (
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        onServicesClick();
                      }}
                      className="fw-semibold text-decoration-none menu-link "
                    >
                      {language === "ar" ? (
                        <span className="ms-2">{item.arabic_name}</span>
                      ) : (
                        <span className="ms-2">{item.name}</span>
                      )}
                      <MdKeyboardArrowDown className="fs-4" />
                    </Link>
                  ) : (
                    <Link
                      className="fw-semibold text-decoration-none menu-link "
                      to={item?.link}
                    >
                      {language === "ar" ? (
                        <span className="ms-2">{item.arabic_name}</span>
                      ) : (
                        <span className="ms-2">{item.name}</span>
                      )}
                    </Link>
                  )}
                </li>
              ))}
            </ul>

            <Link
              to="/contact-us/"
              className="btn-custom d-inline-flex align-items-center gap-2 mx-4 text-decoration-none"
            >
              <span>Contact Now</span>
              <MdOutlineKeyboardDoubleArrowRight className="fs-3" />
            </Link>

            {/* <div
              className="position-relative d-inline-block "
              onClick={() => navigate("/cart")}
              style={{ cursor: "pointer", marginRight: "20px" }}
            >
              <BsCart3 className="fs-4 text-dark " />
              {cartItems.length > 0 && (
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                  style={{ fontSize: "0.65rem", padding: "4px 6px" }}
                >
                  {cartItems.length}
                </span>
              )}
            </div>
            <div
              className="position-relative d-inline-block "
              onClick={() => navigate("/wallet")}
              style={{ cursor: "pointer", marginRight: "20px" }}
            >
              <IoWalletOutline className="fs-4 text-dark " />
            </div> */}
            {/* <div
              className="position-relative me-3"
              onClick={toggleUserDropdown}
              style={{ cursor: "pointer" }}
            >
              <FiUser
                className="fs-3 text-dark"
                onClick={
                  isLoggedIn
                    ? toggleUserDropdown
                    : () => handleUserOptionClick("login")
                }
              />

              {!isLoggedIn && (
                <div className="position-absolute start-50 translate-x-n50 mt-1 animate-bounce">
                  <div
                    className="triangle-up mx-auto"
                    style={{
                      width: 0,
                      height: 0,
                      borderLeft: "5px solid transparent",
                      borderRight: "5px solid transparent",
                      borderBottom: "5px solid #1a1a1a",
                    }}
                  ></div>
                  <div className="bg-dark text-white px-2 py-1 rounded text-xs nowrap">
                    Login
                  </div>
                </div>
              )}

              {isLoggedIn && (
                <div
                  className={`position-absolute end-0 mt-2 py-2 bg-white rounded shadow border border-light animated-dropdown ${
                    showUserDropdown ? "show" : ""
                  }`}
                  style={{ width: "220px", zIndex: 1100 }}
                >
                  <div
                    className="dropdown-item px-4 pb-2 pt-3 d-flex align-items-center hover-bg-light"
                    onClick={() => handleUserOptionClick("profile")}
                  >
                    <FiUser className="me-3" size={20} />
                    <span className="fw-medium">Booked Service</span>
                  </div>
                  <div
                    className="dropdown-item px-4 py-2 d-flex align-items-center hover-bg-light"
                    onClick={() => handleUserOptionClick("wallet")}
                  >
                    <FiCreditCard className="me-3" size={20} />
                    <span className="fw-medium">Wallet</span>
                  </div>
                  <div
                    className="dropdown-item px-4 py-2 d-flex align-items-center hover-bg-light"
                    onClick={() => handleUserOptionClick("cart")}
                  >
                    <FiShoppingCart className="me-3" size={20} />
                    <span className="fw-medium">Cart</span>
                    {cartItems.length > 0 && (
                      <span
                        className="ms-auto text-white text-xs fw-bold px-2 py-1 rounded-pill"
                        style={{
                          backgroundColor: "#c69933",
                        }}
                      >
                        {cartItems.length}
                      </span>
                    )}
                  </div>
                  <div className="border-top my-1"></div>

                  <div
                    className="dropdown-item px-4 py-3 d-flex align-items-center text-danger hover-bg-light"
                    onClick={() => handleUserOptionClick("logout")}
                  >
                    <FiLogOut className="me-3" size={20} />
                    <span className="fw-medium">Logout</span>
                  </div>
                </div>
              )}
            </div> */}
            <LanguageDropdown />

            {/* Modal */}
            <SignInModal
              show={showSignIn}
              handleClose={() => setShowSignIn(false)}
              switchToSignUp={() => {
                setShowSignIn(false);
                setShowSignUp(true);
              }}
            />

            <SignUpModal
              show={showSignUp}
              handleClose={() => setShowSignUp(false)}
              switchToSignIn={() => {
                setShowSignUp(false);
                setShowSignIn(true);
              }}
            />

            {/* Modal backdrop */}
            {showModal && (
              <div
                className="modal-backdrop fade show"
                onClick={handleClose}
              ></div>
            )}
          </div>
        </>
      ) : (
        <div className="mobile-menu">
          <div className="mobile-menu__panels">
            <div
              className={`mobile-menu__panel ${
                activePanel === "main" ? "active" : ""
              }`}
            >
              {renderMainMenu()}
            </div>
            <div
              className={`mobile-menu__panel ${
                activePanel === "services" ? "active" : ""
              }`}
            >
              {renderServicesMenu()}
            </div>
            <div
              className={`mobile-menu__panel ${
                activePanel.startsWith("services-") ? "active" : ""
              }`}
            >
              {renderChildMenu()}
            </div>
            <div
              className={`mobile-menu__panel ${
                activePanel.startsWith("child-") ? "active" : ""
              }`}
            >
              {renderNestedMenu()}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MainMenu;
